import { CouponsTable } from '@/components/features/coupons'

export const Coupons = () => {
  return <CouponsTable />
}
